import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ComplainFormPage from "../components/ComplainFormPage";

const ComplainForm = () => {
  return (
    <div>
      <MasterLayout>
        <ComplainFormPage />
      </MasterLayout>
    </div>
  );
};

export default ComplainForm;
